$(() => {
  const contactBtn = document.getElementById("contact-btn");
  const detailsBtn = document.getElementById("scroll-details-btn");
  const offerJoinSection = document.querySelector(".offer-join");
  const detailsSection = document.querySelector('[data-section="details"]');
  const contactSection = document.querySelector('[data-section="contact"]');
  const offerContainer = document.querySelector(".offer");
  const offerTopBar = document.getElementById("offer-top-bar");
  const offerBottomBar = document.getElementById("offer-bottom-bar");
  setBarVisibility(offerTopBar);
  setBarVisibility(offerBottomBar);
  document.addEventListener("scroll", () => {
    setBarVisibility(offerTopBar);
    setBarVisibility(offerBottomBar);
  });
  handleScrollToSection(detailsBtn, detailsSection);
  handleScrollToSection(contactBtn, contactSection);
  function handleScrollToSection(triggerButton, section) {
    if (!triggerButton) {
      return;
    }
    triggerButton.addEventListener("click", (event) => {
      const offset = 96;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  }
  function setBarVisibility(barElement) {
    const propertyName = "--offer-bar-hidden";
    if (!offerJoinSection) {
      return;
    }
    const visible = offerJoinSection.getBoundingClientRect().bottom < 0;
    if (visible) {
      barElement.setAttribute("aria-hidden", "false");
      barElement.style.setProperty(propertyName, "0");
      offerContainer.classList.add("bar-visible");
      barElement.querySelectorAll("a,button").forEach((element) => {
        if (element.getAttribute("aria-disabled") === "true") {
          element.setAttribute("tabindex", "-1");
          return;
        }
        element.setAttribute("tabindex", "0");
      });
    } else {
      barElement.setAttribute("aria-hidden", "true");
      barElement.style.setProperty(propertyName, "1");
      offerContainer.classList.remove("bar-visible");
      barElement.querySelectorAll("a,button").forEach((element) => element.setAttribute("tabindex", "-1"));
    }
  }
});
